import {createStyles, Theme} from "@material-ui/core";
import {blueBackgroundColor, primaryColor, styleColors} from "src/main.style";

export const MonthviewStyle = (theme: Theme) => createStyles({
  erasedSchedule : {
    position: 'fixed',
    top: '300px',
    zIndex: 10,
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '30px',
    whiteSpace: 'nowrap',
    fontWeight: 700,
    backgroundColor: styleColors.white,
    pointerEvents: 'none',
    boxShadow: `0 0 30px ${styleColors.white}`,
  },
  monthViewport : {
    width: '100%',
    position: 'fixed',
    top: '65px',
    height: 'calc((100% - 50px)*0.3)',
    maxHeight: 'calc((100% - 50px)*0.3)',
    minHeight: 'calc((100% - 50px)*0.3)',
    overflowY: 'auto',
    scrollSnapType: 'y mandatory',
    transition: 'background-color 0.2s',
    userSelect:'none',
    WebkitUserSelect: 'none',
  },
  monthViewportHeader : {
    position: 'absolute',
    top: '70px',
    backgroundColor: styleColors.white,
    zIndex: 3,
    left: '50%',
    transform: 'translate(-50%, 0px)',
    borderRadius: '20px',
    padding: '10px 40px',
    boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
    color: styleColors.greyDark3,
    fontWeight: 600,
    fontSize: '16px',
    transition: 'all 0.5s',
    transitionDelay: '1s',
    opacity: 0,
    overflow: 'hidden',
  },
  month: {
    scrollSnapStop: 'always',
    scrollSnapAlign: 'start',
    position:"relative",
    // overflow: 'hidden',
    boxSizing: 'border-box',
    padding: '8px 0px',
  },
  monthScrollName : {
    position: 'absolute',
    width: '100%',
    top: '-8px',
    zIndex: 5,
    display:'flex',
    justifyContent:'center',
    transition: 'opacity 0.5s',
  },
  monthScrollNameLabel : {
    fontSize: '12px',
    fontWeight: 600,
    color: styleColors.greyDark2,
    /* Match the calendar day cells behind, not the card surface — the
       label sits on top of the scrolling calendar grid. */
    backgroundColor: blueBackgroundColor,
    zIndex: 1,
    padding: '0px 10px',
  },
  monthScrollNameLine : {
    borderTop: `1px solid ${styleColors.greyDark2}`,
    position: 'absolute',
    top: '6px',
    width: '90%',
    left: '5%',
  },
  week: {
    height:'20%',
    display: 'flex',
    justifyContent: 'space-around',
    transition: 'all 0.2s',
    overflow: 'hidden',
  },
  weekSnap:{
    scrollSnapStop: 'always',
    scrollSnapAlign: 'start',
  },
  day: {
    backgroundColor: blueBackgroundColor,
    height: '100%',
    minHeight: '40px',
    width: 'calc(100% / 7)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    boxSizing: 'border-box',
    position:'relative',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
  fakeDay: {
    // backgroundColor: blueBackgroundColor,
    height: '100%',
    minHeight: '40px',
    width: 'calc(100% / 7)',
    boxSizing: 'border-box',
    position:'relative',
  },
  weekNumber : {
    width: '21px',
    display: 'flex',
    fontSize: '10px',
    justifyContent: 'center',
    color: styleColors.greyDark2,
    padding: '2px 0px',
  },
  dayBox : {
    width: '100%',
    height: '100%',
    position: 'absolute',
    boxSizing: 'border-box',
    transition: 'all 0.3s',
    top: 0,
    left: 0,
  },
  dayBorder : {
    borderTop: `1px solid ${styleColors.calendarLineStrong}`,
    borderRight: `1px solid ${styleColors.calendarLineSubtle}`,
  },
  dayBorderLastDays : {
    height: 'calc(100% + 1px)',
    borderBottom: `1px solid ${styleColors.calendarLineStrong}`,
  },
  dayBorderTopRow : {
    height: 'calc(100% + 1px)',
    borderTop: `1px solid ${styleColors.calendarLineTransparent}`,
  },
  dayBorderLeftRow : {
    borderLeft: `1px solid ${styleColors.calendarLineSubtle}`,
  },
  dayNoBorder : {
    borderTop: `0px solid ${styleColors.calendarLineStrong}`,
    borderRight: `0px solid ${styleColors.calendarLineSubtle}`,
  },
  dayBorderSelected : {
    backgroundColor: styleColors.blueTint12,
    border: `1px solid ${styleColors.cornflowerBlue}`,
  },
  dayBorderHighlight : {
    backgroundColor: styleColors.softYellowTint12,
    /* Border uses a dedicated token that's solid in light mode and
       ~17% alpha in dark mode so the highlight doesn't overpower the
       darker calendar grid. */
    border: `1px solid ${styleColors.softYellowBorder}`,
  },
  dayBorderTodayMedium : {
    backgroundColor: styleColors.brightCoralTint12,
    border: `1px solid ${styleColors.brightCoral}`,
    borderRadius: '3px',
    height: '100%',
  },
  dayBorderTodayLarge : {
    backgroundColor: styleColors.brightCoralTint12,
    /* Dimmer border in dark mode so the today-highlight doesn't shout. */
    border: `1px solid ${styleColors.brightCoralBorder}`,
  },
  dayToday : {
    backgroundColor: styleColors.greyLight3,
  },
  dayEventDot : {
    minWidth: '4px',
    minHeight: '4px',
    backgroundColor: primaryColor,
    borderRadius: '3px',
    opacity: 1,
    margin: '3px',
    transition: 'all 0.2s'
  },
  dayEventDotHidden : {
    minWidth: '4px',
    minHeight: '0px',
    backgroundColor: styleColors.greyMedium2,
    borderRadius: '3px',
    margin: '0px',
    opacity: 0,
    transition: 'all 0.2s'
  },
  dayDate : {
    fontSize: '11px',
    borderRadius: '3px',
    marginTop: '1px',
    fontWeight: 400,
    margin: '2px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    minHeight: '13px',
    transition: 'transform 0.3s',
    /* Default body text in dark mode is near-white (greyDark2) which
       reads as harsh against the dark calendar grid. Dim the day
       numbers to a medium grey in both themes. */
    color: styleColors.greyMedium3,
  },
  dayTodayHeader : {
    color: styleColors.blackAlpha93,
    transform: 'scale(1.3)',
    zIndex: 1,
    fontWeight: 600,
    boxSizing: 'border-box',
    // borderRadius: '10px',
    minHeight: '18px',
    minWidth: '18px',
    margin: '2px -0px -4px',
    textShadow: `1px 0px 3px ${styleColors.white}, -1px 0px 3px ${styleColors.white}`,
    fontSize: '16px',
  },
  dayIsHoliday : {
    color: styleColors.pureRed,
    fontWeight: 600,
  },
  dayIsSpecialDay : {
    fontWeight: 600,
  },
  /* Pinned to the bottom right corner instead of taking the space left
     under the events: event chips don't shrink, so in a full day they
     would push the checkmark out of the cell. Above the multi-day bars
     (z-index 1), under the touch areas (z-index 10). */
  daySelectedEditMarkSpace : {
    position: 'absolute',
    right: 0,
    bottom: 0,
    zIndex: 2,
    display: 'flex',
    pointerEvents: 'none',
  },
  daySelectedMarkSelected : {
    width: '14px',
    height: '14px',
    minWidth: '14px',
    minHeight: '14px',
    marginBottom: '3px',
    marginRight: '4px',
    color: styleColors.cornflowerBlue,
    opacity: 1,
    transition: 'all 0.2s',
  },
  daySelectedMarkUnselected : {
    width: '0px',
    height: '0px',
    minWidth: '0px',
    minHeight: '0px',
    marginBottom: '0px',
    marginRight: '0px',
    color: styleColors.cornflowerBlue,
    opacity: 0,
    transition: 'all 0.2s',
  },
  dayHandoverLocation : {
    display: 'flex',
    fontSize: '8px',
    marginBottom: '1px',
    width: '100%',
    justifyContent: 'space-around',
  },
  /* Stacks a day's handover rows on invisible copies of other days'
     rows, so the block is as tall as the tallest of them. */
  alignedHandovers : {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    width: '100%',
  },
  alignedHandoversLayer : {
    gridArea: '1 / 1',
    minWidth: 0,
  },
  custodyBar : {
    width:'100%',
    height:'max(12%,2px)',
    minHeight:'max(12%,2px)',
    position: 'relative',
    marginBottom: '4px',
    transition: 'all 0.6s'
  },
  custodyBarEdit : {
    width:'100%',
    height:'max(14%,2px)',
    minHeight:'max(14%,2px)',
    position: 'relative',
    marginBottom: '2px',
    transition: 'all 0.6s'
  },
  custodyBarEditLarge : {
    width:'100%',
    height:'max(20%,2px)',
    minHeight:'max(20%,2px)',
    position: 'relative',
    marginBottom: '2px',
    transition: 'all 0.6s'
  },
  custodyBarEditExtreme : {
    width:'100%',
    height:'max(calc(100% - 30px),2px)',
    minHeight:'max(calc(100% - 30px),2px)',
    position: 'relative',
    marginBottom: '2px',
    transition: 'all 0.3s'
  },
  custodyBarHidden : {
    width:'100%',
    height:'0px',
    minHeight:'0px',
    position: 'relative',
    marginBottom: '0px',
    opacity: 0,
    transition: 'all 0.3s'
  },
  custodyBarOld : {
    opacity: 0.25,
    marginTop: '6px',
  },
  custodyBarReserved : {
    visibility: 'hidden',
  },
  custodyFullDay : {
    width:'100%',
    height:'100%',
    transition: 'background-color 0.3s',
    /* Background is the parent's color which is constant across themes,
       so text on top must always be actual white. styleColors.white
       flips to the card surface in dark mode. */
    color: '#FFFFFF',
    textShadow: '0px 0px 2px #00000088',
    fontSize: '8px',
    alignContent: 'center',
    textAlign: 'center',
  },
  custodyMorning : {
    width:'25%',
    height:'100%',
    position: 'absolute',
    left: 0,
    borderRadius: '0px 3px 3px 0px',
    /* Background is the parent's color which is constant across themes,
       so text on top must always be actual white. styleColors.white
       flips to the card surface in dark mode. */
    color: '#FFFFFF',
    fontSize: '8px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontWeight: 200,
    transition: 'background-color 0.3s',
  },
  custodyNight : {
    width:'25%',
    height:'100%',
    position: 'absolute',
    right: 0,
    borderRadius: '3px 0px 0px 3px',
    /* Background is the parent's color which is constant across themes,
       so text on top must always be actual white. styleColors.white
       flips to the card surface in dark mode. */
    color: '#FFFFFF',
    fontSize: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontWeight: 200,
    transition: 'background-color 0.3s',
  },
  custodyVisit : {
    width: '70%',
    height: 'calc(100% + 12px)',
    minHeight: 'calc(100% + 12px)',
    position: 'absolute',
    left: '15%',
    fontSize: '8px',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    transition: 'background-color 0.3s',
    overflow: 'hidden',
    transform: 'translateY(-6px)',
    // textOverflow: 'ellipsis',
    // display: '-webkit-box',
    // '-webkit-line-clamp': 2,
    // '-webkit-box-orient': 'vertical',
  },
  event : {
    width: 'calc(100% - 1px)',
    padding: '1px 2px',
    borderRadius: '2px',
    boxSizing: 'border-box',
    marginLeft: '1px',
    marginBottom: '1px',
    fontSize: '11px',
    /* Every chip in every day is equally tall, so the lanes of a week
       line up under the multi-day bars: a fixed line height, so an emoji
       or icon in a title can't make it taller, and no shrinking in a full
       day (the overflowing chips get cut off at the bottom instead). */
    lineHeight: '11px',
    flexShrink: 0,
    // fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    transition: 'opacity 1s, padding 0.3s',
    /* Event chips have pastel/parent-colored backgrounds that are the
       same in both themes — text must always be black so it remains
       readable on top. Default body color (light grey in dark mode)
       would otherwise wash out against the pastels. */
    color: '#000000',
  },
  lanesStart : {
    flexShrink: 0,
    width: '100%',
    height: '0px',
  },
  eventTime : {
    fontSize: '6px',
  },
  eventTitle : {
    fontSize: '6px',
  },
  guideHeader : {
    fontSize: '20px',
    flex:1, 
    paddingLeft:'12px',
  },
  guideButton : {
    backgroundColor : styleColors.greyLight2,
    padding:'12px',
    fontSize: '16px',
    fontWeight: 500,
    borderRadius: '4px',
    border: `1px solid ${styleColors.greyMedium1}`,
  },
  guideLabel : {
    whiteSpace: 'normal',
  },
});



// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/monthview.style.ts